import { h } from 'vue'
import MoleculeLightIntegrations from '~/components/molecules/light-integrations/light-integrations.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentImage from '~ui/components/image/image.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentWrapper, { class: 'light-integrations' }, () => [
    h(UiComponentImage, {
      class: 'pattern',
      expectedSize: props.lightIntergrationsWidth,
      height: props.lightIntergrationsHeight,
      orientation:
        props.lightIntergrationsWidth
        / props.lightIntergrationsHeight
        >= 1
          ? 'landscape'
          : 'portrait',
      source:
        'https://livestorm.imgix.net/1127/1626701065-pattern-dark-integration-light.png',
      width: props.lightIntergrationsWidth,
    }),
    h(UiComponentHeading, { level: 2, theme: 'dark' }, () => [
      props.record.title,
    ]),
    h(MoleculeLightIntegrations, {
      integrations: props.record.integrations.map(integration => ({
        backgroundColor: integration.backgroundColor,
        logo: integration.logoSmall,
      })),
    }),
  ])
}

Functional.props = {
  lightIntergrationsHeight: {
    required: true,
    type: Number,
  },
  lightIntergrationsWidth: {
    required: true,
    type: Number,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
